import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withGetScreen } from "react-getscreen";
import CardCompanies from "../CardCompanies/CardCompanies";
import Tabs from "../Tabs/Tabs";

const options = [{ id: 1, category: "Nacionais" }, { id: 2, category: "Internacionais" }];

class BoxCompanies extends Component {
	constructor() {
		super();
		this.state = {
			tabActive: options[0].id,
			seeMorePrograms: false
		};

		this.setOptionActive = this.setOptionActive.bind(this);
	}

	setOptionActive(id) {
		this.setState({ tabActive: id });
	}

	render() {
		const { companies, isMobile, onClick } = this.props;
		const { tabActive, seeMorePrograms } = this.state;

		const itemNationalCompanies = companies.map(item => {
			const { id, acronym, fidelityName, international } = item;
			return (
				international === "0" && (
					<CardCompanies
						key={id}
						className="box-companies--card"
						width={!isMobile() ? "160px" : undefined}
						height={!isMobile() ? "93px" : "83px"}
						company={acronym}
						programFidelity={fidelityName}
						onClick={() => onClick(item)}
						dataAction={`simulator-miles-fidelity-select-${
							acronym ? acronym.toLowerCase() : fidelityName.toLowerCase()
						}`}
					/>
				)
			);
		});

		const itemInternationalCompanies = !seeMorePrograms
			? companies
					.filter(item => item.international != 0)
					.map((item, idx) => {
						const { id, acronym, fidelityName } = item;
						return (
							idx < 5 && (
								<CardCompanies
									key={id}
									className="box-companies--card"
									width={!isMobile() ? "160px" : undefined}
									height={!isMobile() ? "93px" : "83px"}
									company={acronym}
									programFidelity={fidelityName}
									onClick={() => onClick(item)}
									dataAction={`simulator-miles-fidelity-select-${
										acronym ? acronym.toLowerCase() : fidelityName.toLowerCase()
									}`}
								/>
							)
						);
					})
			: companies.map(item => {
					const { id, acronym, fidelityName, international } = item;
					return (
						international === "1" && (
							<CardCompanies
								key={id}
								className="box-companies--card"
								width={!isMobile() ? "160px" : undefined}
								height={!isMobile() ? "93px" : "83px"}
								company={acronym}
								programFidelity={fidelityName}
								onClick={() => onClick(item)}
								dataAction={`simulator-miles-fidelity-select-${
									acronym ? acronym.toLowerCase() : fidelityName.toLowerCase()
								}`}
							/>
						)
					);
			  });
		return (
			<div className="box-companies">
				{!isMobile() ? (
					<>
						{itemNationalCompanies.find(cia => !!cia) && (
							<>
								<p className="box-companies--title">Programas de fidelidade nacionais</p>
								<div className="box-companies--component">{itemNationalCompanies}</div>
							</>
						)}
						{itemInternationalCompanies.find(cia => !!cia) && (
							<>
								<p className="box-companies--title">Programas de fidelidade internacionais</p>
								<div className="box-companies--component">{itemInternationalCompanies}</div>
								{!seeMorePrograms && (
									<div className="box-companies--see-more-programs">
										<a
											href="#"
											onClick={() => this.setState({ seeMorePrograms: !seeMorePrograms })}
											data-action="see-more-programs"
										>
											Ver mais programas
										</a>
									</div>
								)}
							</>
						)}
						{!itemNationalCompanies.find(cia => !!cia) &&
							!itemInternationalCompanies.find(cia => !!cia) && (
								<div className="box-companies--none">
									<strong>Nenhum resultado encontrado</strong>
									<span>Confira o nome do programa de fidelidade e tente novamente.</span>
									<div className="box-companies--none--img" />
								</div>
							)}
					</>
				) : (
					<>
						<p className="box-companies--mobile--title">
							Selecione abaixo o programa onde estão suas milhas:
						</p>
						<Tabs
							className="box-companies--tabs"
							options={options}
							optionActive={tabActive}
							setOptionActive={this.setOptionActive}
						/>
						<div className="box-companies--component">
							{tabActive === 1 ? itemNationalCompanies : itemInternationalCompanies}
						</div>
						{tabActive !== 1 && !seeMorePrograms && (
							<div className="box-companies--see-more-programs">
								<a
									href="#"
									onClick={() => this.setState({ seeMorePrograms: !seeMorePrograms })}
									data-action="see-more-programs"
								>
									Ver mais programas
								</a>
							</div>
						)}
					</>
				)}
			</div>
		);
	}
}

BoxCompanies.propTypes = {
	companies: PropTypes.array.isRequired,
	onClick: PropTypes.func.isRequired
};

export default connect()(
	withGetScreen(BoxCompanies, {
		mobileLimit: 576, // TODO Fix screen vars
		tabletLimit: 768, // TODO Fix screen vars
		shouldListenOnResize: true
	})
);
